import type { FC } from "react";
import { Banner } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";

export interface NotificationPushUnavailableBannerProps {
  /**
   * `"noActiveDevice"` (the default): none of the user's devices is
   * registered for push. `"checkFailed"`: that could not be found out, so
   * the banner says only that, rather than claiming there is no device.
   */
  readonly reason?: "noActiveDevice" | "checkFailed";
}

/**
 * Why Push can't be ticked on a screen that has no device of its own to
 * register (web): push can only be turned on from the mobile app, and this
 * screen goes by whether any of the user's devices has done so.
 */
export const NotificationPushUnavailableBanner: FC<NotificationPushUnavailableBannerProps> = ({
  reason = "noActiveDevice",
}) =>
  reason === "checkFailed" ?
    <Banner
      variant="warning"
      message="Couldn't check whether push notifications are set up on your phone. Try again later."
    />
  : <Banner
      variant="info"
      title="Push notifications need to be turned on in the mobile app first."
      message="Open Settings → Notification Preferences on your phone and turn on Push notifications."
    />;
